<template>
  <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myLargeModalLabel">Download Report</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <address>
                <strong class="text-capitalize">Report Title</strong><br>
                Housing Units Report - {{ property.property }}
              </address>
            </div>

            <div class="col-12">
              <label><strong>Report Date Range</strong></label>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-xl-6 col-sm-6">
                  <div class="mb-3">
                    <label class="form-label">Date From</label>
                    <input v-model="dateFrom" class="form-control" placeholder="Start date" type="date">
                  </div>
                </div>

                <div class="col-xl-6 col-sm-6">
                  <div class="mb-3">
                    <label class="form-label">Date To</label>
                    <input v-model="dateTo" class="form-control" placeholder="End date" type="date">
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <label><strong>Select File Type</strong></label>
              <select v-model="fileType" class="form-select">
                <option value="">Select Document Type</option>
                <option value="pdf">PDF file</option>
                <option value="excel">Excel File</option>
              </select>
            </div>

            <div class="col-12">
              <button @click="downloadReport" type="button" class="btn btn-primary dropdown-toggle option-selector text-capitalize w-100 mt-5">
                <i class="bx bxs-download font-size-16"></i>
                <span class="pl-1 d-md-inline">{{ downloading ? 'Downloading...' : 'Download Report' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { executeDownload, rent } from "@/api";

export default {
  name: "ReceiptingModal",
  props: {
    modalId: {
      type: String,
      default: "download-modal"
    },
    property: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dateFrom: '',
      dateTo: '',
      fileType: '',
      downloading: false
    };
  },
  methods: {
    downloadReport() {
      if (!this.fileType) {
        alert("Please select a file type");
        return;
      }

      this.downloading = true;

      const data = new FormData();
      data.append("function", "downloadUnitsReport");
      data.append("propertyID", sessionStorage.getItem("propertyID"));
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("fileType", this.fileType);

      executeDownload(data, rent)
          .then(response => {
            this.downloading = false;
            const link = document.createElement('a');
            link.href = URL.createObjectURL(response.data);
            link.download = `Housing_Report.${this.fileType === 'pdf' ? 'pdf' : 'xlsx'}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Close modal
            const modal = window.bootstrap.Modal.getInstance(document.getElementById(this.modalId));
            if (modal) modal.hide();
          })
          .catch(() => {
            this.downloading = false;
            alert("Failed to download report");
          });
    }
  }
};
</script>